import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Form.scss';
import store from '../../store';
import formSlice from './formSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faMagicWandSparkles, faSearch } from '@fortawesome/free-solid-svg-icons';
import analyzeSlice from '../analyze/analyzeSlice';

const Form = (props) => {
  const [numbersSelected, setNumbersSelected] = useState([]);

  const navigate = useNavigate();

  const select = (number) => {
    if (numbersSelected.includes(number)) {
      const newNumbersSelected = numbersSelected.slice();
      newNumbersSelected.splice(newNumbersSelected.indexOf(number), 1)
      setNumbersSelected(newNumbersSelected);
    } else if (numbersSelected.length < 5) {
      setNumbersSelected([...numbersSelected, number]);
    }
  };

  const showResults = () => {
    store.dispatch(formSlice.actions.updateNumbers(numbersSelected));
    navigate('/table');
  };

  const analyze = () => {
    store.dispatch(analyzeSlice.actions.updateKeyNumbers(numbersSelected));
    navigate('/analyze');
  };

  return (
    <div className="Form">
      <div className="table">
        <div className="numbers">
          {
            Array.from(Array(45)).map((n, i) => {
              return (
                <div
                  key={i}
                  className={`${numbersSelected.includes(i + 1) ? 'selected' : ''} ${numbersSelected.length === 5 ? 'disabled' : ''}`}
                  onClick={select.bind(this, i + 1)}
                >
                  {i + 1}
                </div>
              );
            })
          }
        </div>

        {
          <button className={`${numbersSelected.length > 1 ? '' : 'hidden'} animate__animated animate__fadeIn`} onClick={showResults}>Επεξεργασία</button>
        }

        {
          <button className={`${numbersSelected.length > 0 ? '' : 'hidden'} btn-analyze animate__animated animate__fadeIn`} onClick={analyze}>Επεξεργασία ως κλειδιά</button>
        }
      </div>

      <button className="btn-enter-dashboard" onClick={() => navigate('/dashboard')}><FontAwesomeIcon icon={faMagicWandSparkles} size="2x" /></button>

      <button className="btn-search" onClick={() => navigate('/search')}><FontAwesomeIcon icon={faSearch} size="2x" /></button>

      <a href="know-how.pdf" className="btn-info"><FontAwesomeIcon icon={faInfoCircle} size="2x" /></a>
    </div>
  );
};

export default Form;
